import userApi from "./index"

export const toggleBookmark = async (questionId) => {
  try {
    const response = await userApi.post("/bookmarks/toggle", { questionId })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllBookmarks = async (page = 1, limit = 10) => {
  try {
    const response = await userApi.get("/bookmarks", {
      params: { page, limit },
    })
    return response.data
  } catch (error) {
    throw error
  }
}
